// How the game list was left (SPEC §4.4; plan 2026-11-04-navigation-return.md §3.2): the tab, how
// far it was scrolled, how many finished games were shown, and the games it showed, so that every
// way back to the list shows it as it was. Kept for the browser tab: the games in memory only, the
// rest also in sessionStorage, so that a reload keeps it; a new visit starts afresh.
const KEY = 'slowgo.list-view';

let view = null;
const lists = {};

function read() {
  if (view) return view;
  view = { tab: 'mine', scrollY: 0, shown: 0 };
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY));
    if (v && (v.tab === 'mine' || v.tab === 'all')) view = { tab: v.tab, scrollY: Number(v.scrollY) || 0, shown: Number(v.shown) || 0 };
  } catch (e) { /* none kept */ }
  return view;
}

// The list as left: { tab, scrollY, shown, list } (list: the games last shown in that tab, or null).
export function listView() {
  const v = read();
  return { ...v, list: lists[v.tab] || null };
}

export function saveListView({ tab, scrollY, shown, list }) {
  view = { tab, scrollY, shown };
  if (list) lists[tab] = list;
  try { sessionStorage.setItem(KEY, JSON.stringify(view)); } catch (e) { /* the memory copy is enough */ }
}

// The games last loaded for a tab, kept to show at once when the player switches back to it.
export function keepList(tab, list) {
  lists[tab] = list;
}
